import { Grid } from "antd";
const { useBreakpoint } = Grid;

function useBreakpoints() {
  const screens = useBreakpoint();
  return {
    isExtraSmall: screens.xs || false,
    isSmall: screens.sm || false,
    isMedium: screens.md || false,
    isLarge: screens.lg || false,
    isExtraLarge: screens.xl || false,
    isDoubleLarge: screens.xxl || false,
  };


}

export default useBreakpoints;
